export default __webpack_public_path__ + "static/media/Export.02d4c5f1.svg";